import { observer } from 'mobx-react';
import { TextLead } from '@awarego-ui/components';
import React from 'react';

function StopCampaignsConfirm({ action, result }) {
    return (
        <TextLead>
            In order to {action}, please{' '}
            <TextLead bold>stop the client's active campaigns</TextLead> through
            the Company {result.activeTrainings > 0 && 'Training'}{' '}
            {result.activeTrainings > 0 &&
                result.activeAssessments > 0 &&
                'and '}
            {result.activeAssessments > 0 && 'Assessment'} pages.
        </TextLead>
    );
}

export default observer(StopCampaignsConfirm);
